import "./index.css"

import {
  defineCustomElementTdsSidenav,
  defineCustomElementTdsSidenavItem,
  defineCustomElementTdsSidenavResponsiveHeader,
  defineCustomElementTdsSidenavSection,
} from "tapestry-wc"

defineCustomElementTdsSidenav()
defineCustomElementTdsSidenavItem()
defineCustomElementTdsSidenavSection()
defineCustomElementTdsSidenavResponsiveHeader()
